import React from 'react';
import { IconCancel, IconCircleCheck } from 'gatorcomponents';

const iconCheck = <IconCircleCheck color="activeLight" />;
const iconCancel = <IconCancel color="problemPure" />;

export default {
  studio: 'HostGator Studio Pro',
  bannerPlans: {
    title: 'Experimente o plano Pro e crie designs profissionais',
    titleTrial: 'Teste o plano Pro grátis por 7 dias',
    subtitle: 'Cancele a qualquer momento. Vamos lembrá-lo antes do término do teste.',
  },
  headerDesc: {
    title: 'Crie como um profissional com o Pro!',
    subtitle: (
      <>
        Desbloqueie a ferramenta do Pro
        <br />
        para decolar sua marca.
      </>
    ),
    planType: 'Tipo de plano:',
    planRecurrence: 'Mensal',
  },
  planFree: {
    priceDesc: 'Grátis no seu plano',
  },
  planPro: {
    trial: '7 dias grátis',
    name: 'Studio Pro',
    priceDesc: price => `${price} ano`,
    recurrence: 'mês',
    buttonLabel: 'Contratar plano',
  },
  tablePlan: [
    {
      id: 1,
      desc: 'Templates gratuítos em diferentes formatos',
      free: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Templates gratuítos em diferentes formatos
          </>
        ),
      },
      pro: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Templates gratuítos em diferentes formatos
          </>
        ),
      },
    },
    {
      id: 2,
      desc: 'Filtros, fontes e templates premium',
      free: {
        desktop: iconCancel,
        mobile: (
          <>
            {iconCancel}
            Filtros, fontes e templates premium
          </>
        ),
      },
      pro: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Filtros, fontes e templates premium
          </>
        ),
      },
    },
    {
      id: 3,
      desc: 'Criação de kit de marca (logo, cores e fontes da marca)',
      free: {
        desktop: iconCancel,
        mobile: (
          <>
            {iconCancel}
            Criação de kit de marca (logo, cores e fontes da marca)
          </>
        ),
      },
      pro: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Criação de kit de marca (logo, cores e fontes da marca)
          </>
        ),
      },
    },
    {
      id: 4,
      desc: 'Criador de logo com IA',
      free: {
        desktop: '10 créditos por mês',
        mobile: (
          <>
            {iconCheck}
            Criador de logo com IA
            <br />
            <small>10 créditos por mês</small>
          </>
        ),
      },
      pro: {
        desktop: '75 créditos por mês',
        mobile: (
          <>
            {iconCheck}
            Criador de logo com IA
            <br />
            <small>75 créditos por mês</small>
          </>
        ),
      },
    },
    {
      id: 5,
      desc: 'Remoção de fundo com IA',
      free: {
        desktop: iconCancel,
        mobile: (
          <>
            {iconCancel}
            Remoção de fundo com IA
          </>
        ),
      },
      pro: {
        desktop: '75 créditos por mês',
        mobile: (
          <>
            {iconCheck}
            Remoção de fundo com IA
          </>
        ),
      },
    },
    {
      id: 6,
      desc: 'Acervo de imagens, ícones, fontes, entre outros recursos',
      free: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Acervo de imagens, ícones, fontes, entre outros recursos
          </>
        ),
      },
      pro: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Acervo de imagens, ícones, fontes, entre outros recursos
          </>
        ),
      },
    },
    {
      id: 7,
      desc: 'Otimização de imagens',
      free: {
        desktop: iconCancel,
        mobile: (
          <>
            {iconCancel}
            Otimização de imagens
          </>
        ),
      },
      pro: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Otimização de imagens
          </>
        ),
      },
    },
    {
      id: 8,
      desc: 'Dimensões personalizadas',
      free: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Dimensões personalizadas
          </>
        ),
      },
      pro: {
        desktop: iconCheck,
        mobile: (
          <>
            {iconCheck}
            Dimensões personalizadas
          </>
        ),
      },
    },
    {
      id: 9,
      desc: 'Editor exclusivo',
      free: {
        desktop: 'Recursos básicos',
        mobile: (
          <>
            {iconCheck}
            Editor exclusivo - Recursos básicos
          </>
        ),
      },
      pro: {
        desktop: 'Recursos avançados',
        mobile: (
          <>
            {iconCheck}
            Editor exclusivo - Recursos avançados
          </>
        ),
      },
    },
    {
      id: 10,
      desc: 'Download em alta resolução',
      free: {
        desktop: 'Limitado',
        mobile: (
          <>
            {iconCheck}
            Download em alta resolução - Limitado
          </>
        ),
      },
      pro: {
        desktop: 'Ilimitado',
        mobile: (
          <>
            {iconCheck}
            Download em alta resolução - Ilimitado
          </>
        ),
      },
    },
  ],
  buttonShowMore: 'Mostrar mais',
  buttonShowLess: 'Mostrar menos',
};
